import { getFirebaseAppInstance } from "@/stores/firebase.store";
import { getAuth } from "firebase/auth";

export const getFirebaseIdToken = async (): Promise<string | undefined> => {
	const app = await getFirebaseAppInstance();
	const user = getAuth(app).currentUser;
	if (!user) return undefined;
	return await user.getIdToken(true);
};
